import { ClickAwayListener, List, ListItem, ListItemButton, ListItemText, Paper, Popper } from '@mui/material';
import Transitions from 'ui-component/extended/Transitions';
import { LogReportMode } from '../../utils';
import { useLocation } from 'react-router-dom';

interface LogReportHeaderMenuProps {
    anchorRef: HTMLElement | null;
    onClose: () => void;
    onChangeSelection: (newSelection: LogReportMode) => () => void;
}

export const LogReportHeaderMenu = ({ anchorRef, onClose, onChangeSelection }: LogReportHeaderMenuProps) => {
    const location = useLocation();
    const curDocViewer = location.pathname.split('/').at(2);
    const viewersWhereAttachmentHistShouldNotDisplay = ['record-details-viewer'];
    const isOpenSelector = !!anchorRef;
    return (
        <Popper
            onResize={null}
            onResizeCapture={null}
            placement="bottom-end"
            open={isOpenSelector}
            anchorEl={anchorRef}
            role={undefined}
            transition
            disablePortal
            sx={{ border: `1px solid #D9D9D9`, borderRadius: '8px !important', zIndex: 9 }}
            popperOptions={{
                modifiers: [{ name: 'offset', options: { offset: [0, 14] } }]
            }}
        >
            {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={onClose}>
                    <Transitions in={isOpenSelector} {...TransitionProps}>
                        <Paper sx={{ borderRadius: '8px !important' }}>
                            {isOpenSelector && (
                                <List>
                                    <ListItem divider disablePadding>
                                        <ListItemButton
                                            sx={(theme) => ({
                                                '&:hover': {
                                                    color: theme.palette.primary[400],
                                                    background: theme.palette.primary[300]
                                                }
                                            })}
                                            onClick={onChangeSelection(LogReportMode.All)}
                                        >
                                            <ListItemText primary="Record History" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem divider disablePadding>
                                        <ListItemButton
                                            sx={(theme) => ({
                                                '&:hover': {
                                                    color: theme.palette.primary[400],
                                                    background: theme.palette.primary[300]
                                                }
                                            })}
                                            onClick={onChangeSelection(LogReportMode.Objects)}
                                        >
                                            <ListItemText primary="Objects History" />
                                        </ListItemButton>
                                    </ListItem>
                                    <ListItem divider disablePadding>
                                        <ListItemButton
                                            sx={(theme) => ({
                                                '&:hover': {
                                                    color: theme.palette.primary[400],
                                                    background: theme.palette.primary[300]
                                                }
                                            })}
                                            onClick={onChangeSelection(LogReportMode.LineItems)}
                                        >
                                            <ListItemText primary="Line items History" />
                                        </ListItemButton>
                                    </ListItem>
                                    {!viewersWhereAttachmentHistShouldNotDisplay.includes(curDocViewer || '') && (
                                        <ListItem divider disablePadding>
                                            <ListItemButton
                                                sx={(theme) => ({
                                                    '&:hover': {
                                                        color: theme.palette.primary[400],
                                                        background: theme.palette.primary[300]
                                                    }
                                                })}
                                                onClick={onChangeSelection(LogReportMode.Attachments)}
                                            >
                                                <ListItemText primary="Attachments History" />
                                            </ListItemButton>
                                        </ListItem>
                                    )}
                                    <ListItem disablePadding>
                                        <ListItemButton
                                            sx={(theme) => ({
                                                '&:hover': {
                                                    color: theme.palette.primary[400],
                                                    background: theme.palette.primary[300]
                                                }
                                            })}
                                            onClick={onChangeSelection(LogReportMode.Comments)}
                                        >
                                            <ListItemText primary="Comments History" />
                                        </ListItemButton>
                                    </ListItem>
                                </List>
                            )}
                        </Paper>
                    </Transitions>
                </ClickAwayListener>
            )}
        </Popper>
    );
};
